import { FoxBizRequest, FoxRestBizClient } from "@/api/client";

/**
 * 포토폴리오 화면 관련 기능 클래스
 */
class Portfolio {

    /**
     * 생성자
     */
    constructor() {

    }

    /**
     * 포토폴리오 사업실적 목록 조회 메서트
     * @returns 
     */
    getBusinessPortfolioItems() {

        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Admin.Biz.SystemBiz';
            request.methodId = 'GetBusinessPortfolioItems';

            service.execute(request).then(response => {

                const rows = response.data.result.value.Table.rows;
                
                if (!!rows.length) resolve(rows);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 포토폴리오 사업실적 목록 조회 메서트
     * @returns 
     */
    getMainBusinessPortfolioAssets() {

        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Admin.Biz.SystemBiz';
            request.methodId = 'GetMainBusinessPortfolioAssets';

            service.execute(request).then(response => {

                if (!!response) resolve(response.data.result.value);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }
}

export const portfolio = new Portfolio();